import PasswordInput from './PasswordInput';

export { PasswordInput };
export type { PasswordInputProps } from './types';
